export default "__VITE_ASSET__B1nPwxB5__"